import React, { useState, useEffect } from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const ReportLoader = () => {
  const [statusIndex, setStatusIndex] = useState(0);
  const statuses = [
    "FETCHING DATABASE RECORDS",
    "SYNCHRONIZING DATA TABLES",
    "GENERATING ANALYTICAL INSIGHTS",
    "FORMATTING EXCEL EXPORT",
    "FINALIZING DOCUMENT STRUCTURE",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setStatusIndex((prev) => (prev + 1) % statuses.length);
    }, 3500);
    return () => clearInterval(interval);
  }, []);
  const theme = useTheme();
  return (
    <Box
      sx={{
        height: "90vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#F8FAFC",
      }}
    >
      {/* ===== LOTTIE ANIMATION ===== */}
      <Box sx={{ width: 300, height: 300, mb: 3 }}>
        <DotLottieReact
          src="https://lottie.host/4cac7171-69ec-48ab-9b90-19613d76ce7e/whtXv07xtq.lottie"
          loop
          autoplay
        />
      </Box>

      <Box sx={{ textAlign: "center", width: "100%", maxWidth: 280 }}>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 900,
            color: "#0F172A",
            letterSpacing: "3px",
            mb: 2,
            textTransform: "uppercase",
          }}
        >
          Report Engine
        </Typography>

        <LinearProgress
          sx={{
            height: 2,
            borderRadius: 1,
            bgcolor: "#E2E8F0",
            "& .MuiLinearProgress-bar": { bgcolor: theme.palette.primary.main },
            mb: 2,
          }}
        />

        <Box sx={{ height: "20px" }}>
          <Typography
            sx={{
              fontSize: "10px",
              color: "#64748B",
              fontWeight: 700,
              letterSpacing: "1px",
            }}
          >
            {statuses[statusIndex]}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          position: "absolute",
          bottom: 30,
          left: 30,
          opacity: 0.3,
          fontFamily: "monospace",
          fontSize: "9px",
          color: "#475569",
          lineHeight: 2,
        }}
      >
        HEX_VAL: 0x4F22
        <br />
        STREAM: STABLE
        <br />
        LOAD_PRIORITY: HIGH
      </Box>
    </Box>
  );
};

export default ReportLoader;
